/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

:host {
  display: none;
  position: absolute;
  z-index: 8;
}

:host([show]) {
  display: inline;
}

:host([hidden]) {
  display: none;
}

.transformdetector {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.modal {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  pointer-events: none;
}
:host([modal]) .modal {
  pointer-events: auto;
}

.modal .overlay {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
:host([modal]) .modal .overlay {
  background-color: #000000;
  background-color: var(--davinci-color-backdrop, #000000);
  opacity: 0.3;
  pointer-events: none;
}

.modal .flex {
  position: absolute;
  pointer-events: all;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-08dp, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  margin: 1.071rem;
  min-width: 3.571rem;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}
:host([type=error]) .modal .flex {
  background-color: #EA0823;
  background-color: var(--davinci-color-error, #EA0823);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-error, #FFFFFF);
}

:host([type=warning]) .modal .flex {
  background-color: #F5C413;
  background-color: var(--davinci-color-warning, #F5C413);
  color: #2C3133;
  color: var(--davinci-color-text-on-warning, #2C3133);
}

:host([type=success]) .modal .flex {
  background-color: #63b017;
  background-color: var(--davinci-color-success, #63b017);
  color: #FFFFFF;
  color: var(--davinci-color-text-on-success, #FFFFFF);
}

.modal .flex .tipShadow {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
  z-index: -1;
}
.modal .flex .tip {
  position: absolute;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-08dp, #FFFFFF);
  color: #2C3133;
  color: var(--davinci-color-text, #2C3133);
  height: 1.143rem;
  width: 1.143rem;
}
:host([type=error]) .modal .flex .tip {
  background-color: #EA0823;
  background-color: var(--davinci-color-error, #EA0823);
}

:host([type=warning]) .modal .flex .tip {
  background-color: #F5C413;
  background-color: var(--davinci-color-warning, #F5C413);
}

:host([type=success]) .modal .flex .tip {
  background-color: #63b017;
  background-color: var(--davinci-color-success, #63b017);
}

.modal .flex.right .tip {
  left: 0;
  transform: translate(-50%, 1.071rem) rotate(45deg);
}
.modal .flex.right.alignbottom .tip {
  left: 0;
  bottom: 0;
  transform: translate(-50%, -1.071rem) rotate(45deg);
}
.modal .flex.bottom .tip {
  top: 0;
  transform: translate(1.071rem, -50%) rotate(45deg);
}
.modal .flex.bottom.alignright .tip {
  top: 0;
  right: 0;
  transform: translate(-1.071rem, -50%) rotate(45deg);
}
.modal .flex.top .tip {
  bottom: 0;
  transform: translate(1.071rem, 50%) rotate(45deg);
}
.modal .flex.top.alignright .tip {
  bottom: 0;
  right: 0;
  transform: translate(-1.071rem, 50%) rotate(45deg);
}
.modal .flex.left .tip {
  right: 0;
  transform: translate(50%, 1.071rem) rotate(45deg);
}
.modal .flex.left.alignbottom .tip {
  right: 0;
  bottom: 0;
  transform: translate(50%, -1.071rem) rotate(45deg);
}
.modal .flex .slot {
  order: 0;
  flex: 1 1 auto;
  align-self: auto;
  padding: 1.429rem;
  font-size: 0.857rem;
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-08dp, #FFFFFF);
}
.modal .flex .slot .headline {
  color: #50585C;
  color: var(--davinci-color-text-light, #50585C);
  fill: #50585C;
  fill: var(--davinci-color-text-light, #50585C);
  font-weight: bold;
  font-size: 1rem;
  margin-bottom: 0.7142857143rem;
}
:host([type=error]) .modal .flex .slot .headline {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-error, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-error, #FFFFFF);
}

:host([type=warning]) .modal .flex .slot .headline {
  color: #2C3133;
  color: var(--davinci-color-text-on-warning, #2C3133);
  fill: #2C3133;
  fill: var(--davinci-color-text-on-warning, #2C3133);
}

:host([type=success]) .modal .flex .slot .headline {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-success, #FFFFFF);
  fill: #FFFFFF;
  fill: var(--davinci-color-text-on-success, #FFFFFF);
}

.modal .flex .slot ::slotted(*) {
  font-size: 0.8571428571rem;
  color: #2C3133;
  color: var(--davinci-color-text-on-background-08dp, #2C3133);
}
:host([type=error]) .modal .flex .slot {
  background-color: #EA0823;
  background-color: var(--davinci-color-error, #EA0823);
}
:host([type=error]) .modal .flex .slot ::slotted(*) {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-error, #FFFFFF);
}

:host([type=warning]) .modal .flex .slot {
  background-color: #F5C413;
  background-color: var(--davinci-color-warning, #F5C413);
}
:host([type=warning]) .modal .flex .slot ::slotted(*) {
  color: #2C3133;
  color: var(--davinci-color-text-on-warning, #2C3133);
}

:host([type=success]) .modal .flex .slot {
  background-color: #63b017;
  background-color: var(--davinci-color-success, #63b017);
}
:host([type=success]) .modal .flex .slot ::slotted(*) {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-success, #FFFFFF);
}`;
export { style };
